import React, { Component } from "react";
import { Text, View, Picker, Image, Platform } from "react-native";
import styles from "../styles";
import theme from "../theme";
import { dynamicSize, getFontSize } from "../helpers";
import { ISelectFormField, OnInputChange, IFormInputCustomProps } from "../base/models/forms";
import DataUtils from "../helpers/data-utils";
import { getCollection } from "../base/firestore-utils";

const INPUT_HEIGHT: number = 40;
const caretIcon = require("../assets/images/icons/caret.png");

export default class FormPicker extends Component<
	{
		field: ISelectFormField;
		placeholder?: string;
		value?: any;
		label: string;
		onInputChange?: OnInputChange;
		invalid?: boolean;
		style?;
		uid?: string;
	} & { customProps?: IFormInputCustomProps }
> {
	state = {
		selectedValue: this.props.value,
		items: this.props.field.selectValues ? ["", ...this.props.field.selectValues] : [],
	};

	componentDidMount() {
		this.setItems();
	}

	async setItems() {
		switch (this.props.field.fieldType) {
			case "yes/no":
				this.setState({ items: ["", "Yes", "No"] });
				break;
			case "boolean":
				this.setState({
					items: [
						{ value: undefined, display: "" },
						{ value: true, display: "Yes" },
						{ value: false, display: "No" },
					],
				});
				break;
			case "collection":
				const items: any[] = await getCollection(
					this.props.field.useFirewire ? DataUtils.context.firewireApp : DataUtils.context.clientFirebase,
					this.props.field.collectionName,
					this.props.field.collectionDisplayField,
					this.props.field.filterQuery
				);
				this.setState({
					items: [{ id: "", [this.props.field.collectionDisplayField]: "" }, ...items],
					selectedValue: this.props.value,
				});
				break;
		}
	}

	render() {
		console.log("FormPicker.render()", this.props);
		const customProps: IFormInputCustomProps = this.props.customProps || ({} as IFormInputCustomProps);

		// const FormPicker = ({ placeholder, value, label, onChange, style, items = [] }) => {
		// const pickerStyle = {
		//   viewContainer: styles.form.pickerViewContainer,
		//   chevronContainer: styles.form.pickerChevronContainer,
		//   inputIOS: [styles.text.formInput, styles.form.input],
		//   inputAndroid: [
		//     {
		//       color: theme.colors.orange
		//     },
		//     styles.form.input
		//   ],
		//   icon: styles.form.pickerIcon,
		//   done: styles.form.pickerDone,
		//   modalViewMiddle: styles.form.pickerModalViewMiddle,
		//   modalViewBottom: styles.form.pickerModalViewBottom,
		//   underline: {
		//     display: "none"
		//   }
		// };

		const invalidStyles = this.props.invalid ? styles.form.invalidInput : {};
		const pickerStyle2 = {
			// styles.text.formInput,
			color: theme.colors.orange,
			fontSize: getFontSize(17),
			fontFamily: "Avenir-Heavy",
			// borderBottomColor: theme.colors.inputBorder,
			// borderBottomColor: theme.colors.orange,
			// paddingVertical: dynamicSize(20),
			// fontSize: getFontSize(12),

			// fontFamily: "Avenir-Heavy",
			// backgroundColor: theme.colors.grey2,
			backgroundColor: "transparent",
			backgroundImage: "none",
			height: INPUT_HEIGHT,
			// color: theme.colors.orange,

			borderTopRightRadius: 0,
			borderTopLeftRadius: 0,
			borderBottomRightRadius: 0,
			borderBottomLeftRadius: 0,
			borderRightWidth: 0,
			borderLeftWidth: 0,
			borderTopWidth: 0,
			borderBottomWidth: 0,
			borderBottomEndRadius: 0,
			borderBottomStartRadius: 0,
			borderTopEndRadius: 0,
			borderTopStartRadius: 0,
			marginTop: dynamicSize(5),
			// borderRadius: 0,
			// height: dynamicSize(INPUT_HEIGHT),
			// underline: {
			//   display: "none"
			// }

			// shadowRadius: 0,
			// ...Platform.select({
			//   web: {
			//     outlineColor: theme.colors.orange,
			//     // borderRadius: 0,
			//     borderTopRightRadius: 0,
			//     borderTopLeftRadius: 0,
			//     borderBottomRightRadius: 0,
			//     borderBottomLeftRadius: 0,
			//     height: "40px"
			//     // borderTopRightRadius: 0,
			//     // borderTopLeftRadius: 0,
			//     // borderBottomRightRadius: 0,
			//     // borderBottomLeftRadius: 0
			//   }
			// })
		};
		// invalidStyles

		return (
			<View
				nativeID={"laco-form-input-" + this.props.field.id}
				style={[
					styles.form.group,
					{ borderBottomColor: theme.colors.inputBorder, borderBottomWidth: 1 },
					invalidStyles,
					this.props.style,
				]}
			>
				{this.props.label && (
					<Text style={styles.text.formLabel} nativeID={"laco-form-input-label-" + this.props.field.id}>
						{this.props.label.toUpperCase()}
						{customProps.showAsterisks && customProps.asteriskTemplate}
					</Text>
				)}
				{!!this.state.items.length && (
					<>
						<Picker
							onValueChange={(value: string, index: number) => {
								this.setState({ selectedValue: value });
								if (this.props.onInputChange) {
									this.props.onInputChange(this.props.field, value);
								}
							}}
							// itemStyle={{ borderRadius: 0, height: dynamicSize(INPUT_HEIGHT) }}
							// itemStyle={pickerStyle.inputIOS}
							itemStyle={[
								styles.text.formInput,
								styles.form.input,
								{ height: INPUT_HEIGHT, color: theme.colors.grey10 },
								Platform.select({
									ios: {
										height: 150,
									},
								}),
							]}
							style={[
								Platform.select({
									android: pickerStyle2,
									web: pickerStyle2,
								}),
							]}
							selectedValue={this.state.selectedValue}
							mode="dropdown"
							enabled={this.props.customProps.enabled}
						>
							{this.state.items.map((item: any, i: number) => {
								let selected: boolean = false;
								switch (this.props.field.fieldType) {
									case "collection": {
										selected = this.state.selectedValue === item.id;
										return (
											<Picker.Item
												color={selected ? theme.colors.orange : undefined}
												key={item.id}
												label={item[this.props.field.collectionDisplayField || "name"]}
												value={item.id}
											/>
										);
									}
									case "boolean": {
										selected = this.state.selectedValue;
										return (
											<Picker.Item
												color={selected ? theme.colors.orange : undefined}
												key={`bool-${i}`}
												label={item.display}
												value={item.value}
											/>
										);
									}
									default: {
										selected = this.state.selectedValue === item;
										return (
											<Picker.Item
												color={selected ? theme.colors.orange : undefined}
												key={i}
												label={(item || "").toString()}
												value={item}
											/>
										);
									}
								}
							})}
						</Picker>
						{Platform.OS === "android" && (
							<Image
								style={{
									position: "absolute",
									bottom: dynamicSize(14),
									right: 0,
								}}
								source={caretIcon}
							/>
						)}
						{/* {Platform.OS === "ios" && (
							<>
								<Text
									style={{
										position: "absolute",
										bottom: 68,
										right: 18,
										fontSize: 11,
										color: theme.colors.grey7,
									}}
								>
									Scroll
								</Text>
								<Image
									style={{
										position: "absolute",
										bottom: 68,
										right: 0,
										height: 15,
										width: 10,
									}}
									source={caretIcon}
								/>
							</>
						)} */}
					</>
				)}
			</View>
		);
	}
}
